// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3hsIC","content":"styles_content__2XFk7","selectAll":"styles_selectAll__3nB6q"};